import { Grid } from "@mui/material";
import ImageLoader from "../components/ImageLoader";
import CustomText from "../components/CustomText";

const AwardsCertifications = () => {
  return (
    <Grid container sx={design.Center}>
      <CustomText variant="subtitle1" color="#000" sx={design.Title}>
        Premios y Certificaciones
      </CustomText>
      <ImageLoader src={Cofepris} alt={"logo"} width={262} height={167} />
      <ImageLoader src={Distintivo} alt={"logo"} width={262} height={167} />
      <ImageLoader src={Certificado} alt={"logo"} width={262} height={167} />
    </Grid>
  );
};
export default AwardsCertifications;
const Certificado =
  "https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_certificado_consejo_saludable_general.png";
const Cofepris =
  "https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_Cofepris_contra_riesgos_sanitarios.png";
const Distintivo =
  "https://centromedicomedam.com/IMG/centromedicoMEDAM/Logo_Distintivo.png";

const design = {
  Title: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: {
      xs: 25,
      sm: 25,
      md: 35,
      lg: 35,
    },
    fontWeight: 600,
    lineHeight: "normal",
    marginTop: "2%",
    textAlign: "center",
    width: "100%",
  },
  Center: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
    gap: 5,
    mb: 5,
  },
};
